import React from 'react';
import { Tag } from 'antd';
import { TagProps } from 'antd/lib/tag';

export type { TagProps };

const ProTag: React.FC<TagProps> = React.forwardRef<any, TagProps>(
  (props, ref) => {
    const { children, ...resProps } = props;

    return (
      <Tag ref={ref} {...resProps}>
        {children}
      </Tag>
    );
  },
);

export default ProTag;
